import React, { useContext, useReducer, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { AuthContext } from "../../../context/AuthContext";

import { SuperAdminMenuList, AdminMenuList, allSubAdminroutes } from "./Menu";
import SuperAdminSidebar from "./SuperAdminSidebar";
import AdminSidebar from "./AdminSidebar";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const { user } = useContext(AuthContext);
  const loginDetails = JSON.parse(localStorage.getItem("login_Details"));

  const { iconHover, sidebarposition, headerposition, sidebarLayout, ChangeIconSidebar } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);
  const [hideOnScroll, setHideOnScroll] = useState(true);

  // Detect scroll to hide the sidebar
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const userType = Number(loginDetails?.user?.user_type ?? loginDetails?.user?.user_level) || (loginDetails?.type === 'superadmin' ? 4 : 3);

  // Filter SuperAdmin menu based on client_id
  const filteredSuperAdminMenuList = SuperAdminMenuList.filter((item) => {
    if (item.title === "Client" && loginDetails?.user?.client_id > 0) {
      return false; // Exclude Client menu if client_id is greater than 0
    }
    if (item.title === "users Category" && loginDetails?.user?.client_id === 0) {
      return false; // Exclude Users Category menu if client_id is 0
    }
    return true;
  });

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          {/* Display menus based on user role */}
          {userType === 4 && (  // Sub-admin check (user_type 4)
            <SuperAdminSidebar
              state={state}
              setState={setState}
              menuListData={filteredSuperAdminMenuList}
            />
          )}

          {userType !== 4 && (  // Admin check (default to Admin)
            <AdminSidebar
              state={state}
              setState={setState}
              menuListData={AdminMenuList}
            />
          )}

          {userType === 4 && (  // Sub-admin menu
            <SuperAdminSidebar
              state={state}
              setState={setState}
              menuListData={allSubAdminroutes}
            />
          )}
        </ul>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
